import { render, staticRenderFns } from "./InspectionList.vue?vue&type=template&id=371451c6&"
import script from "./InspectionList.vue?vue&type=script&lang=js&"
export * from "./InspectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports